<template>
  <div :class="containerClass">
    <div class="d-felx" :class="topTitleClass">
      <label v-if="topTitle != ''" class="d-inline">{{ topTitle }}</label>
      <span v-if="required" class="text-danger mx-1">*</span>
      <p
        class="text-secondary"
        v-if="digitTranslate != '' && !showTraslateOnButton"
      >
        <small>
          {{ digitTranslate }}
        </small>
      </p>
    </div>
    <div class="p-0" :class="{ 'input-group': hasLeftBox }">
      <input
        ref="inputControl"
        v-if="copmponentType == 'input'"
        :id="ID"
        :placeholder="inputPlaceHolder"
        :type="
          inputType == 'intNumber' || inputType == 'floatNumber'
            ? 'text'
            : inputType
        "
        :disabled="disableInput"
        class="form-control"
        :class="inputComputed"
        :value="displayValue"
        :dir="
          hasLeftBox && (inputType == 'intNumber' || inputType == 'floatNumber')
            ? 'ltr'
            : 'rtl'
        "
        @input="onInput($event)"
        @keypress="
          inputType == 'intNumber' || inputType == 'floatNumber'
            ? inputKeyPress($event)
            : ''
        "
        :maxlength="hasMaxLength ? maxLength : undefined"
      />
      <textarea
        ref="inputControl"
        v-if="copmponentType == 'textArea'"
        :disabled="disableInput"
        :placeholder="inputPlaceHolder"
        :type="inputType"
        class="form-control order-2"
        :class="inputClass"
        :value="inputValue"
        @keydown="textAreakeydown"
        @input="textAreaInput"
      />
      <span
        @click="leftBoxOnClick"
        v-if="hasLeftBox"
        class="input-group-text order-3"
        :class="leftBoxClass"
      >
        <!-- <font-awesome-icon
          :class="leftIconClass"
          class="d-inline-block"
          :icon="inputType == 'password' ? passwordIcon : leftIconName"
          :spin="leftIconSpin"
          v-if="inputType == 'password' ? true : leftShowIcon"
          :id="ID + 'icon'"
        /> -->
        {{ leftBoxTitle }}</span
      >
      <!-- <span class="inputSpanTitle" :class="sideBoxComputed">
        <font-awesome-icon
          :class="iconClass"
          class="d-inline-block"
          :icon="iconName"
          :spin="iconSpin"
          v-if="showIcon"
        />
        {{ inputTitle }}</span
      > -->
    </div>
    <div>
      <p
        class="text-secondary"
        v-if="digitTranslate != '' && showTraslateOnButton"
      >
        <small>
          {{ digitTranslate }}
        </small>
      </p>
      <span
        v-if="
          maxSpaceTextArea != 0 ? showMessageDynamic : showMessage || !validated
        "
        :class="erroMessageClass"
        >{{ errorMessage }}</span
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      digitTranslate: '',
      displayValue: '',
      validated: true,
      passwordIcon: 'eye-slash',
      showMessageDynamic: false,
      persianNumbers: [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers: [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ],
    };
  },
  props: {
    showTraslateOnButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxSpaceTextArea: {
      type: Number,
      required: false,
      default: 0,
    },
    ID: {
      type: String,
      required: false,
      default: null,
    },
    leftIconClass: {
      type: String,
      require: false,
      default: '',
    },
    disableInput: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDigiTranslate: {
      type: Boolean,
      required: false,
      default: false,
    },
    digitSepratorChar: {
      type: String,
      required: false,
      default: ',',
    },
    inputSize: {
      type: String,
      required: false,
      default: 'sm', //lg , ''
    },

    floatPointChar: {
      type: String,
      required: false,
      default: ',',
    },
    isDigitSeprator: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasLeftBox: {
      type: Boolean,
      required: false,
      default: false,
    },
    leftBoxClass: {
      type: String,
      required: false,
      default: '',
    },
    leftBoxTitle: {
      type: String,
      required: false,
      default: '',
    },
    leftBoxClick: {
      typeof: Function,
      required: false,
      default: null,
    },

    copmponentType: {
      type: String,
      required: false,
      default: 'input',
    },
    sideBoxClass: {
      type: String,
      required: false,
    },
    topTitleClass: {
      type: String,
      required: false,
      default: '',
    },

    topTitle: {
      type: String,
      required: false,
      default: '',
    },
    iconName: {
      type: [String, Array],
      require: false,
    },
    leftIconName: {
      type: [String, Array],
      require: false,
    },
    leftIconSpin: {
      type: Boolean,
      default: false,
      required: false,
    },
    iconSpin: {
      type: Boolean,
      default: false,
      required: false,
    },
    inputTitle: {
      type: String,
      default: '',
      required: false,
    },
    inputPlaceHolder: {
      type: String,
      required: false,
      default: '',
    },
    inputType: {
      type: String,
      required: false,
      default: 'text',
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
    erroMessageClass: {
      type: String,
      required: false,
      default: 'text-danger',
    },
    inputThem: {
      type: String,
      required: false,
      default: 'whiteThem',
    },
    showMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    inputValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    inputValueWithLeftBox: {
      type: [String, Number],
      required: false,
      default: '',
    },
    hasMaxLength: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
    },
  },
  computed: {
    showIcon() {
      return this.iconName == undefined ? false : true;
    },
    leftShowIcon() {
      return this.leftIconName == undefined ? false : true;
    },
    iconClass() {
      return this.inputTitle == '' ? '' : 'me-1';
    },
    // sideBoxComputed() {
    //   return !this.hasSideBox
    //     ? `simpleSideBox ${this.sideBoxClass}`
    //     : this.sideBoxClass;
    // },
    inputComputed() {
      return `${this.inputClass} ${
        this.hasLeftBox ? 'inputHasLeftBox' : 'inputHasNotLeftBox'
      } ${
        this.inputSize == 'sm'
          ? 'form-control-sm'
          : this.inputSize == 'lg'
          ? 'form-control-lg'
          : ''
      } ${!this.validated ? 'isNotValid' : ''} `;
    },
  },
  methods: {
    textAreaInput(e) {
      if (
        e.target.value.split(' ').length - 1 > this.maxSpaceTextArea &&
        this.maxSpaceTextArea != 0
      ) {
        e.target.value = '';
        this.showMessageDynamic = true;
        this.$emit('update:inputValue', e.target.value.replaceAll('\n', ''));
      } else {
        this.showMessageDynamic = false;
        this.$emit('update:inputValue', e.target.value);
      }
    },
    textAreakeydown(e) {
      if (this.maxSpaceTextArea == 0) return;
      if (e.key == 'Enter') {
        e.preventDefault();
      }
      if (
        e.target.value.split(' ').length - 1 == this.maxSpaceTextArea &&
        e.code === 'Space' &&
        !e.ctrlKey &&
        this.maxSpaceTextArea != 0
      ) {
        e.preventDefault();
        this.showMessageDynamic = true;
      } else this.showMessageDynamic = false;
    },
    leftBoxOnClick() {
      if (this.leftBoxClick) {
        this.leftBoxClick();
        return;
      }

      if (this.inputType == 'password') {
        let input = document.getElementById(this.ID);
        if (input.getAttribute('type') === 'password') {
          this.passwordIcon = 'eye';
        } else {
          this.passwordIcon = 'eye-slash';
        }
        const type =
          input.getAttribute('type') === 'password' ? 'text' : 'password';
        input.setAttribute('type', type);
      }
    },
    updateValues(newValue) {
      //----------------------- Set display value of input
      if (
        this.isDigitSeprator &&
        (this.inputType == 'intNumber' || this.inputType == 'floatNumber')
      ) {
        newValue
          ? (this.$data.displayValue = thousandSeprator(
              newValue,
              this.digitSepratorChar,
              this.floatPointChar
            ))
          : (this.$data.displayValue = '');
        if (this.showDigiTranslate)
          this.digitTranslate = numberToWord(newValue);
      } else {
        this.$data.displayValue = newValue;
      }
      //-------------------------- update inputValue with leftBox text
      if (this.hasLeftBox) {
        this.$emit(
          'update:inputValueWithLeftBox',
          `${this.leftBoxTitle}${newValue}`
        );
      }
    },
    toEnglishNumbers(str) {
      if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
          str = str
            .replace(this.persianNumbers[i], i)
            .replace(this.arabicNumbers[i], i);
        }
      }
      return str;
    },
    onInput(event) {
      let valueWithOutSep = event.target.value;
      if (this.isDigitSeprator) {
        event.target.value = this.toEnglishNumbers(valueWithOutSep);
        valueWithOutSep = removeSeprator(event.target.value);
      }

      //----------------------- Update inputValue property
      this.$emit('update:inputValue', valueWithOutSep);
      //----------------------- Update inputValue property with leftBox tex
      if (this.hasLeftBox) {
        this.$emit(
          'update:inputValueWithLeftBox',
          `${this.leftBoxTitle}${valueWithOutSep}`
        );
      }
      //----------------------- Update digitTranslate property when showDigitTranslate enabled
      if (this.showDigiTranslate) {
        this.digitTranslate = numberToWord(valueWithOutSep);
      }
      this.validated = true;
    },
    // Handle number and value typing ↓
    inputKeyPress(event) {
      // int number condition ↓
      if (this.inputType === 'intNumber') {
        if (
          !(
            (event.which >= 48 && event.which <= 57) ||
            (event.which >= 1776 && event.which <= 1785)
          )
        ) {
          event.preventDefault();
        }
      }

      // float number condition ↓
      if (this.inputType === 'floatNumber') {
        if (
          (event.which != 46 || event.target.value.indexOf('.') != -1) &&
          !(
            (event.which >= 48 && event.which <= 57) ||
            (event.which >= 1776 && event.which <= 1785)
          )
        ) {
          event.preventDefault();
        }
      }
    },
    setFocus() {
      this.$refs.inputControl.focus();
    },
    showErrorMessage() {
      this.validated = false;
    },
    hideErrorMessage() {
      this.validated = true;
    },
  },
  watch: {
    inputValue: function (newValue) {
      this.updateValues(newValue);
    },
    inputValueWithLeftBox: function (newValue) {
      this.updateValues(
        newValue.includes(this.leftBoxTitle)
          ? newValue.split(this.leftBoxTitle)[1]
          : newValue
      );
    },
  },
  mounted() {
    this.updateValues(this.inputValue);
    if (this.inputType == 'password' && this.hasLeftBox) {
      document.getElementById(this.ID + 'icon').style.cursor = 'pointer';
    }
  },
  updated() {},
};
</script>

<style scoped>
.isNotValid {
  border-color: #f64e60;
}
/* Colors : white - #484e5e DarkGray - #4d5361 Gray - #7b7ce6 Purple  */
.simpleSideBox {
  padding-right: 2px;
  padding-left: 0px;
}
.inputHasLeftBox {
  border-left: 0px;
  border-radius: 0px;
}
.inputHasNotLeftBox {
  /* border-radius: 5px 0px 0px 5px !important; */
}
span.order-3 {
  border-radius: 5px 0px 0px 5px !important;
  padding: 5px;
  border-right: 2px #ccd1df solid;
}

input.order-2,
textarea.order-2 {
  transition: all 0.5s linear;
  border-radius: 0px;
  /* border-right: unset; */
  outline: none !important;
  box-shadow: none;
  border-color: #ccd1df;
}
span.inputSpanTitle {
  border-color: #ccd1df;
  border-radius: 0px 5px 5px 0px !important;
}
/* ----------------- WhiteThem ----------------- */
/* .whiteThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: white;
  color: #7b7ce6;
}
.whiteThem:hover > span.inputSpanTitle,
.whiteThem > input:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #697183;
  color: rgb(255, 255, 255);
} */
/* ----------------- GrayThem ----------------- */
/* .grayThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #697183;
  color: #dadbff;
}
.grayThem:hover > span.inputSpanTitle,
.grayThem > input:focus ~ span.inputSpanTitle,
.grayThem > textarea:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #7b7ce6;
  color: white;
}
.grayThem > input:focus,
.grayThem > textarea:focus {
  box-shadow: 0 6px 6px -6px #7b7ce6;
} */
/* ----------------- DarkGrayThem ----------------- */
/* .darkGrayThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #484e5e;
  color: #adaeff;
}
.darkGrayThem:hover > span.inputSpanTitle,
.darkGrayThem > input:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #697183;
  color: rgb(226, 226, 226);
} */
/* ----------------- PurpleThem ----------------- */
/* .purpleThem > span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: #7b7ce6;
  color: rgb(255, 255, 255);
}
.purpleThem:hover > span.inputSpanTitle,
.purpleThem > input:focus ~ span.inputSpanTitle {
  transition: all 0.5s linear;
  background-color: white;
  color: #7b7ce6;
} */
</style>
